import { PrimaryButton } from 'src/shared/design-system/Buttons';
import styled, { css } from 'styled-components';
import { ifProp } from 'web-common/src/shared/styled-utils/ifProp';
import { Border, Colors, Font, Mixins, Spacing, Transition } from 'web-common/src/shared/styles';

export const Container = styled.div`
  ${Mixins.Flex.setColumn()}
  gap: ${Spacing.DOUBLE};
  height: 100%;
  width: 100%;
  padding: ${Spacing.DOUBLE} 0;

  ${Mixins.Media.maxWidthSmall(css`
    justify-content: space-between;
    padding-bottom: 0;
  `)}
`;

export const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  width: 100%;

  ${Mixins.Media.maxWidthSmall(css`
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
  `)}
`;

export const Section = styled.div`
  flex: 1 1 100%;
  padding: 0 ${Spacing.SINGLE_HALF};
  width: 100%;

  &:not(:first-child) {
    border-left: ${Border.Base} ${Colors.GRAY_LITE_10};
  }

  ${Mixins.Media.maxWidthSmall(css`
    flex: 0 1 auto;
    margin-bottom: ${Spacing.DOUBLE};

    &:not(:first-child) {
      border-left: none;
    }

    &:last-child {
      margin-bottom: 0;
    }
  `)}
`;

export const LoadingContainer = styled(Container)`
  ${Mixins.Flex.center('row')}
  margin-top: ${Spacing.DOUBLE_HALF};
  width: 100%;

  ${Mixins.Media.maxWidthSmall(css`
    align-items: flex-start;
    justify-content: flex-start;
    flex-direction: column;
    padding-top: ${Spacing.DOUBLE};
    margin-top: 0;

    & ${Section} {
      margin-bottom: 0px;
    }
  `)}
`;

export const SectionLoading = styled(Section)`
  &:not(:first-child) {
    border-left: none;
  }
`;

export const SectionHeader = styled.h3`
  margin: 0 0 ${Spacing.SINGLE} !important;
  font-size: ${Font.Size.S} !important;
  ${Font.bySize(Font.Size.S)}

  ${Mixins.Media.maxWidthSmall(css`
    margin-bottom: ${Spacing.HALF} !important;
  `)}
`;

export const SectionResults = styled.div`
  ${Mixins.Flex.setColumn()}
  gap: ${Spacing.HALF};

  ${Mixins.Media.minWidthSmall(css`
    & > *:nth-child(3) {
      // Only show 2 dishes on desktop
      display: none;
    }
  `)}

  ${Mixins.Media.maxWidthSmall(css`
    gap: ${Spacing.EIGHTH};
  `)}
`;

export const NoResultsContainer = styled.div`
  ${Mixins.Flex.centerColumn()}
  gap: ${Spacing.SINGLE}
`;

export const NoResultsText = styled.div`
  ${Font.bySize(Font.Size.L, Font.Weight.BOLD)}
  color: ${Colors.GRAY_DARK_30};
  text-align: center;
`;

export const NoResultsSubtext = styled.div`
  ${Font.bySize(Font.Size.S, Font.Weight.MEDIUM)}
  color: ${Colors.GRAY_DARK_30};
  text-align: center;
`;

export const PressEnterText = styled.div<{ show?: boolean }>`
  ${Font.bySize(Font.Size.S, Font.Weight.SEMI_BOLD)}
  color: ${Colors.GRAY_DARK_10};
  text-align: center;
  transition: opacity ${Transition.Time.BASE}, margin-top ${Transition.Time.BASE};
  display: block;

  ${ifProp(
    'show',
    css`
      margin-top: 0px;
      opacity: 1;
      pointer-events: all;
    `,
    css`
      margin-top: -${Spacing.SINGLE};
      opacity: 0;
      pointer-events: none;
    `
  )}

  ${Mixins.Media.maxWidthSmall(css`
    display: none;
  `)}
`;

export const ViewResultsContainer = styled.div`
  ${Mixins.Flex.centerColumn()}
  ${Mixins.Media.maxWidthSmall(css`
    background: ${Colors.WHITE};
    text-align: center;
    padding: ${Spacing.SINGLE};
    position: sticky;
    bottom: 0;
  `)}
`;

export const ViewResultsButton = styled(PrimaryButton.M)`
  border-radius: ${Border.Radius.M};
  width: 300px;

  ${Mixins.Media.maxWidthSmall(css`
    width: 100%;
  `)}
`;
